import {  useMemo } from "react";
import { useSelector } from "react-redux";
import RefreshIcon from '@mui/icons-material/Refresh';

import ButtonComponent from "../../../components/buttonComponent";
import FilterHeader from "../../../components/FilterHeader";

const AvisPageHeader = (props) => {
  const {
    isInternal,
    setProvider,
    providerList,
    supplierName,
    handleTableRefresh,
    // Filter props
    isFiltered,
    filterTitle,
    totalFilteredOrders,
    onClearFilter,
    filterSource
  } = props;

  // Get the selected provider from Redux state
  const selectedProvider = useSelector((storeState) => storeState.setProvider);

  // providerList.sort();

  const pl = useMemo(
    () =>
      providerList.sort(function (a, b) {
        return a.descr.localeCompare(b.descr, "en", { sensitivity: "base" });
      }),
    [providerList]
  );

  return (
    <div
      id="avis-header-div"
      className="flex flex-nowrap space-x-1 w-full pl-2 mr-0 my-1 justify-between items-center h-12"
    >
      {isInternal ? (
        <div id="avis-internal-select" className="w-1/2 flex items-center h-full" xs={130}>
          <div className="flex items-center h-full">
            <select
              className="cstm-select focus:outline-none focus:shadow-green-700 focus:shadow-md block text-[0.8rem]"
              id="inputGroupSelect01"
              value={selectedProvider || ""}
              onChange={(evt) => setProvider(evt.target.value)}
            >
              <option value="" id="">
                Select Forwarder
              </option>
              {pl.map((providerOption) => (
                <option
                  value={providerOption.sapSuplrNo}
                  id={providerOption.providerId}
                  key={providerOption.providerId}
                >
                  {providerOption.descr}
                </option>
              ))}
            </select>
          </div>
          {/* Filter Header positioned right next to select component */}
          <div className="flex items-center h-full pt-3 pl-2">
            <FilterHeader
              isFiltered={isFiltered}
              filterTitle={filterTitle}
              totalFilteredOrders={totalFilteredOrders}
              onClearFilter={onClearFilter}
              filterSource={filterSource}
            />
          </div>
        </div>
      ) : (
        <div className="w-1/2 flex items-center space-x-2 h-full">
          <div className="flex items-center h-full">
            <h6
              id="avis-supplier-name"
              className="pl-3 font-semibold text-xs"
            >
              {supplierName}
            </h6>
          </div>
          {/* Filter Header positioned right next to supplier name */}
          <div className="flex items-center h-full pt-1 pl-2">
            <FilterHeader
              isFiltered={isFiltered}
              filterTitle={filterTitle}
              totalFilteredOrders={totalFilteredOrders}
              onClearFilter={onClearFilter}
              filterSource={filterSource}
            />
          </div>
        </div>
      )}
      
      <div id="avis-title" className="flex-1 flex items-center justify-start h-full">
        <p id="avis-title-p-tag" className="text-xs">
          <b className="">AVIS</b>
        </p>
      </div>
      
      <div className="flex items-center h-full">
        <ButtonComponent
          handleFunction={handleTableRefresh}
          tooltip={"Refresh Data"}
          variant={null}
        >
          <RefreshIcon style={{ fontSize: '20px' }} />
        </ButtonComponent>
      </div>
    </div>
  );
};

export default AvisPageHeader;
